import snakeCase from "lodash/snakeCase"
import isArray from "lodash/isArray"
import isObject from "lodash/isObject"
import mapKeys from "lodash/mapKeys"
import mapValues from "lodash/mapValues"

export default function snakeCaseKeys(obj) {
  if (isArray(obj)) {
    return obj.map(snakeCaseKeys)
  } else if (isObject(obj)) {
    const withMappedKeys = mapKeys(obj, (_, keys) => snakeCase(keys))
    return mapValues(withMappedKeys, snakeCaseKeys)
  } else {
    return obj
  }
}
